const PATIENT_CHECKIN_STORAGE_KEY = 'patient_checkin_state_v1';
export const PATIENT_CHECKIN_UPDATED_EVENT = 'patient-checkin-updated';

interface PatientCheckinState {
  [patientKey: string]: string;
}

const normalizeName = (value?: string): string => value?.trim().toLowerCase() ?? '';

const buildPatientKey = (patientId?: string, patientName?: string): string =>
  patientId?.trim() || normalizeName(patientName) || 'default';

const loadState = (): PatientCheckinState => {
  try {
    const raw = localStorage.getItem(PATIENT_CHECKIN_STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as unknown;
    return typeof parsed === 'object' && parsed !== null ? (parsed as PatientCheckinState) : {};
  } catch {
    return {};
  }
};

const saveState = (state: PatientCheckinState): void => {
  localStorage.setItem(PATIENT_CHECKIN_STORAGE_KEY, JSON.stringify(state));

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(PATIENT_CHECKIN_UPDATED_EVENT));
  }
};

export const markPatientCheckinCompleted = (
  patientId?: string,
  patientName?: string,
  completedAt = new Date().toISOString()
): void => {
  const patientKey = buildPatientKey(patientId, patientName);
  const state = loadState();
  saveState({
    ...state,
    [patientKey]: completedAt,
  });
};

export const loadLastPatientCheckinAt = (patientId?: string, patientName?: string): string | undefined => {
  const patientKey = buildPatientKey(patientId, patientName);
  return loadState()[patientKey];
};
